import crypto from 'crypto-browserify'

/**
 * Format device id as a mac address
 * @param uid Device ID
 */
export function formatMacFromID(uid: string): string {
    const g: string[] =
        uid
            .toUpperCase() // Capitalize all letters
            .replace(/[^\d|A-F]/gi, '') // Remove all non hex characters
            .slice(0, 12) // Not more than 12 characters long
            .match(/.{1,2}/g) || [] // Get characters grouped two by two
    return g.join(':') // Join all groups with colons
}

export function md5(value: string): string {
    return crypto.createHash('md5').update(value, 'utf8').digest('hex')
}

export default {
    formatMacFromID,
    md5,
}
